import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        order: {
          ...store.getState().i18n.translations.en.common.order,
          allPriceIncludeVATText: {
            ALL_PRICE_INCLUDE_VAT: 'All prices exclude VAT',
          },
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        order: {
          ...store.getState().i18n.translations.vi.common.order,
          allPriceIncludeVATText: {
            ALL_PRICE_INCLUDE_VAT: 'Giá chưa bao gồm VAT',
          },
        },
      },
    },
  }),
)
